import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M12 12.5a8.875 8.875 0 0 1 8.875 8.875.75.75 0 1 1-1.5 0 7.375 7.375 0 0 0-14.75 0 .75.75 0 1 1-1.5 0A8.875 8.875 0 0 1 12 12.5zm0-10.625a5.125 5.125 0 1 1 0 10.25 5.125 5.125 0 0 1 0-10.25zm0 1.5a3.625 3.625 0 1 0 0 7.25 3.625 3.625 0 0 0 0-7.25z' />
  </svg>
);
